import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDatepickerModule, NgbPaginationModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxLoadingModule } from "ngx-loading";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { BoardItemComponent } from '../features/data-visualization/boards/board-item/board-item.component';
import { ReportDataComponent } from '../features/data-visualization/reports/report-data/report-data.component';
import { ReportItemComponent } from '../features/data-visualization/reports/report-item/report-item.component';
import { ReportParametersComponent } from '../features/data-visualization/reports/report-parameters/report-parameters.component';
import { CardComponent } from './components/card/card.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { DynamicTypeaheadComponent } from './components/dinamic-typeahead/dynamic-typeahead.component';
import { ModalComponent } from './components/modal/modal.component';
import { MultipleInputComponent } from './components/multiple-input/multiple-input.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PasswordComponent } from './components/password/password.component';
import { ScrollPaginatorComponent } from './components/scroll-paginator/scroll-paginator.component';
import { ScrolldownButtonComponent } from './components/scrolldown-button/scrolldown-button.component';
import { TableComponent } from './components/table/table.component';
import { TypeInputComponent } from './components/type-input/type-input.component';
import { TypeaheadComponent } from './components/typeahead/typeahead.component';
@NgModule({
  declarations: [
    CardComponent,
    ScrolldownButtonComponent,
    ModalComponent,
    ReportItemComponent,
    ReportDataComponent,
    ReportParametersComponent,
    BoardItemComponent,
    ModalComponent,
    TypeInputComponent,
    TypeaheadComponent,
    ConfirmationModalComponent,
    PaginatorComponent,
    ScrollPaginatorComponent,
    TableComponent,
    MultipleInputComponent,
    DynamicTypeaheadComponent,
    PasswordComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgxLoadingModule.forRoot({
      primaryColour: "#ff9500",
      secondaryColour: "#ff9500",
      tertiaryColour: "#ff9500",
      backdropBackgroundColour: "rgba(255,255,255,0.7)",
      backdropBorderRadius: "0.5rem"
    }),
    NgxMaskDirective,
    NgxMaskPipe,
    NgbTypeaheadModule,
    NgbPaginationModule,
    InfiniteScrollModule,
    NgbTooltipModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    CardComponent,
    ScrolldownButtonComponent,
    ModalComponent,
    ReportItemComponent,
    ReportDataComponent,
    ReportParametersComponent,
    BoardItemComponent,
    TypeInputComponent,
    MultipleInputComponent,
    TypeaheadComponent,
    DynamicTypeaheadComponent,
    ConfirmationModalComponent,
    NgxLoadingModule,
    PaginatorComponent,
    ScrollPaginatorComponent,
    TableComponent,
    PasswordComponent
  ],
  providers: [provideNgxMask(),
  ]
})
export class SharedModule { }